import React from 'react';

const Users = ({ width = 20, height = 15, colour = '' }) => {
    return (
        <svg className={'stroke-current ' + colour} viewBox="0 0 20.337 15.583" height={height} width={width}>
            <g transform="translate(0 -3.525)">
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                    d="M4.063,7.9A3.527,3.527,0,1,0,7.589,4.375,3.527,3.527,0,0,0,4.063,7.9Z"
                    transform="translate(-1.155)"
                />
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                    d="M.625,22.684a5.809,5.809,0,1,1,11.618,0Z"
                    transform="translate(0 -4.201)"
                />
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                    d="M16.575,5.621a3.526,3.526,0,1,1,.614,5.136,3.636,3.636,0,0,1-.415-.356"
                    transform="translate(-5.361 -0.001)"
                />
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                    d="M18.125,17.116a5.813,5.813,0,0,1,7.469,5.568H20.2"
                    transform="translate(-5.882 -4.201)"
                />
            </g>
        </svg>
    );
};

export default Users;
